import React, { PureComponent, ReactNode } from "react";
import { MusicNoteIdentity, MusicScale } from "../../../wasm/pkg/wasm";
import { listAllNoteIds, toNoteName, toNoteNameNoContext } from "../../models/wasm.model";
import "./StringTuningColumn.css";
import { retuneString, StringsTuning } from "./InstrumentTypes.model";

interface Props {
  tuning: StringsTuning;
  onUpdateTuning: (tuning: StringsTuning) => void;
  scale?: MusicScale;
}
interface State {
  noteNameMap: Partial<Record<MusicNoteIdentity, string>>;
}

class StringTuningColumn extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      noteNameMap: {},
    };
  }

  onComponentDidUpdate(oldProps: Props) {
    if (this.props.scale && (oldProps.scale?.family !== this.props.scale.family || oldProps.scale?.shape !== this.props.scale.shape)) {
      const noteNameMap: Partial<Record<MusicNoteIdentity, string>> = {};
      this.props.scale?.shape_notes.forEach((n) => {
        noteNameMap[n.note_id] = toNoteName(n.note_id, this.props.scale);
      });
      this.setState({
        noteNameMap,
      });
    }
  }

  curryHandleTuningChange = (stringIndex: number) => (event: React.ChangeEvent<HTMLSelectElement>) => {
    const tuning = retuneString(this.props.tuning, stringIndex, event.target.value as MusicNoteIdentity);
    this.props.onUpdateTuning({ ...tuning });
  };

  renderNoteDropdown(selection: MusicNoteIdentity, stringIndex: number): ReactNode {
    const noteNamesAndIds = listAllNoteIds().map((noteId) => {
      const noteName = this.state.noteNameMap[noteId] || toNoteNameNoContext(noteId);
      return { noteId, noteName };
    });
    const selectorId = `string-tuning-${stringIndex}`;
    return (
      <select
        className="string-tuning-dropdown"
        key={selectorId}
        value={selection}
        name={selectorId}
        id={selectorId}
        onChange={this.curryHandleTuningChange(stringIndex)}
      >
        {noteNamesAndIds.map(({ noteId, noteName }) => {
          const key = `tune-${stringIndex}-op${noteId}`;
          return (
            <option key={key} value={noteId}>
              {noteName}
            </option>
          );
        })}
      </select>
    );
  }

  render(): ReactNode {
    const { tuning } = this.props;
    return (
      <div className="strings-tuning-column">
        {tuning.stringsLowToHigh.map((str, noteIndex) => {
          return this.renderNoteDropdown(str[0], noteIndex);
        })}
        <div className="instrumentation-pre-neck-spacer"></div>
      </div>
    );
  }
}

export default StringTuningColumn;
